export { default as Contract } from './contract/screen/Contract'; 
export { default as XemNhatKy } from './contract/screen/XemNhatKy';

export {default as Request } from './request/screen/Request'; 